// src/App.js
import React from 'react';
//import { Helmet } from 'react-helmet';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Contact from './pages/Contact';
import Header from './components/Header';
import Footer from './components/Footer';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';

function App() {
  //const serviceId = Services.id;
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<Contact />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:serviceId" element={<ServiceDetail />} />
            {/* Add more routes for Services, Products, Company, etc */}
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
